export const isTouchInteraction = (
	event: MouseEvent | TouchEvent | PointerEvent
) =>
	event.type.startsWith("touch") ||
	("pointerType" in event && event.pointerType === "touch");
